module.exports = __webpack_public_path__ + "img/west-vvip-gal-7.8db2f8dd.jpg";